import { render, staticRenderFns } from "./CreateTeam.view.vue?vue&type=template&id=47a5000a&scoped=true&"
import script from "./CreateTeam.view.vue?vue&type=script&lang=js&"
export * from "./CreateTeam.view.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeam.view.vue?vue&type=style&index=0&id=47a5000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5000a",
  null
  
)

export default component.exports